import { Bell } from 'lucide-react';
import { useEffect, useMemo, useState } from 'react';
import { fetchAdminAlerts } from '../services/integrations';

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const latest = await fetchAdminAlerts();
        if (alive) setAlerts(latest);
      } catch (err) {
        if (alive) {
          setAlerts([{
            id: 'alerts-unavailable',
            severity: 'warning',
            title: 'Alerts unavailable',
            description: err?.message || 'Could not refresh admin alerts.',
          }]);
        }
      }
    };
    load();
    const timer = setInterval(load, 30000);
    return () => {
      alive = false;
      clearInterval(timer);
    };
  }, []);

  const unreadCount = useMemo(() => alerts.filter((alert) => alert.severity !== 'info').length, [alerts]);

  return (
    <div className="wb-notifications">
      <button
        type="button"
        className="wb-icon-button"
        aria-label="Notifications"
        onClick={() => setOpen((value) => !value)}
      >
        <Bell size={18} />
        {unreadCount ? <span className="wb-notification-dot">{unreadCount}</span> : null}
      </button>
      {open ? (
        <div className="wb-notification-menu">
          <div className="wb-notification-menu__header">
            <strong>Alerts</strong>
            <span>{alerts.length} total</span>
          </div>
          {alerts.length ? alerts.map((alert) => (
            <div className={`wb-notification-item wb-notification-item--${alert.severity}`} key={alert.id}>
              <strong>{alert.title}</strong>
              <span>{alert.description}</span>
            </div>
          )) : (
            <div className="wb-notification-empty">No alerts right now.</div>
          )}
        </div>
      ) : null}
    </div>
  );
}
